import React, { useEffect, useState } from "react";

import { AnimatedDone, Concluido, FormCadastro } from "./styles";
import {
  ContainerPublic as Container,
  OverlayPublic as Overlay,
} from "../../../styles/GlobalStyles";

import Input from "../../../components/Input";
import Header from "../../../components/Header";
import {
  isStrongPassword,
  mascaraCelular,
  mascaraCnpj,
  validaCnpj,
  validaEmail,
  validaTelefone,
} from "../../../services/utils";
import { FaIoxhost } from "react-icons/fa";
import { api } from "../../../services/api";
import { useRef } from "react";
import { useHistory } from "react-router-dom";
import Alerts from "../../../components/Alerts";
import InputPassword from "../../../components/InputPassword";
import InputCheckbox from "../../../components/InputCheckbox";
import { signIn } from "../../../services/security";

function CadastroEmpresa() {
  const headerLinks = [
    { label: "Já tenho cadastro", to: "/" },
    { label: "Admin", to: "/admin" },
  ];

  const history = useHistory();

  const btnEnviarRef = useRef();

  const [aceiteTermo, setAceiteTermo] = useState(false);

  const [empresa, setEmpresa] = useState({
    cnpj: "",
    nome_fantasia: "",
    nome_contato: "",
    email_contato: "",
    telefone_contato: "",
    senha: "",
  });
  const [mensagemErro, setMensagemErro] = useState({
    cnpj: "",
    nome_fantasia: "",
    nome_contato: "",
    email_contato: "",
    telefone_contato: "",
    senha: "",
    termo: "",
  });

  const [concluido, setConcluido] = useState(false);

  const [mensagem, setMensagem] = useState(undefined);

  //habilita / desabilita botão
  useEffect(() => {
    const empresaProps = Object.values(empresa);
    const mensagemErroProps = Object.values(mensagemErro);

    let buttonDisabled = true;

    empresaProps.some((p) => {
      if (p === "") {
        buttonDisabled = true;
        return true;
      }
      buttonDisabled = false;
      return false;
    });

    if (!buttonDisabled) {
      mensagemErroProps.some((p) => {
        if (p !== "") {
          buttonDisabled = true;
          return true;
        }
        buttonDisabled = false;
        return false;
      });
    }

    if (!aceiteTermo) buttonDisabled = true;

    btnEnviarRef.current.disabled = buttonDisabled;
  }, [empresa, mensagemErro, aceiteTermo]);

  const handlerCnpj = (e) => {
    setEmpresa({ ...empresa, cnpj: mascaraCnpj(e.target.value) });
    if (!validaCnpj(e.target.value))
      setMensagemErro({ ...mensagemErro, cnpj: "CNPJ Inválido" });
    else {
      setMensagemErro({ ...mensagemErro, cnpj: "" });
    }
  };

  const handlerInput = (e) => {
    setEmpresa({ ...empresa, [e.target.id]: e.target.value });

    if (e.target.value.length === 0)
      setMensagemErro({ ...mensagemErro, [e.target.id]: "Campo obrigatório" });
    else setMensagemErro({ ...mensagemErro, [e.target.id]: "" });
  };

  const handlerNomeContato = (e) => {
    setEmpresa({
      ...empresa,
      [e.target.id]: e.target.value.replace(/\d/g, ""),
    });

    if (e.target.value.length === 0)
      setMensagemErro({ ...mensagemErro, [e.target.id]: "Campo obrigatório" });
    else setMensagemErro({ ...mensagemErro, [e.target.id]: "" });
  };

  const handlerCelular = (e) => {
    setEmpresa({
      ...empresa,
      telefone_contato: mascaraCelular(e.target.value),
    });

    if (!validaTelefone(e.target.value))
      setMensagemErro((e) => ({
        ...e,
        telefone_contato: "Telefone inválido",
      }));
    else
      setMensagemErro((e) => ({
        ...e,
        telefone_contato: "",
      }));
  };

  const handlerEmail = (e) => {
    setEmpresa({
      ...empresa,
      email_contato: e.target.value,
    });

    if (!validaEmail(e.target.value))
      setMensagemErro((e) => ({
        ...e,
        email_contato: "E-mail inválido",
      }));
    else
      setMensagemErro((e) => ({
        ...e,
        email_contato: "",
      }));
  };

  const handlerSenha = (e) => {
    setEmpresa({
      ...empresa,
      senha: e.target.value,
    });

    if (!isStrongPassword(e.target.value))
      setMensagemErro((e) => ({
        ...e,
        senha: "A senha precisa ser forte",
      }));
    else
      setMensagemErro((e) => ({
        ...e,
        senha: "",
      }));
  };

  const enviar = async (e) => {
    e.preventDefault();

    const novaEmpresa = Object.assign({}, empresa);

    novaEmpresa.cnpj = novaEmpresa.cnpj.replace(/[^0-9]+/g, "");
    novaEmpresa.telefone_contato = novaEmpresa.telefone_contato.replace(
      /[^0-9]+/g,
      ""
    );

    btnEnviarRef.current.innerHTML = "Enviando...";
    btnEnviarRef.current.disabled = true;

    try {
      const response = await api.post("empresas/", novaEmpresa);

      signIn(response.data);

      btnEnviarRef.current.innerHTML = "OK!";
      btnEnviarRef.current.disabled = false;

      setTimeout(() => {
        setConcluido(true);
      }, 500);
    } catch (e) {
      let msgErro = { show: true, titulo: "Erro" };
      if (e.response) msgErro.detalhe = e.response.data.erro;
      else
        msgErro.detalhe =
          "Desculpe, houve um problema. Tente novamente mais tarde.";
      btnEnviarRef.current.innerHTML = "Enviar";
      btnEnviarRef.current.disabled = false;
      setMensagem(msgErro);
    }
  };

  return (
    <>
      <Alerts mensagem={mensagem} setMensagem={setMensagem} tipo="erro" />
      <Container>
        <Header links={headerLinks} />
        {concluido ? (
          <Concluido>
            Tudo certo!
            <AnimatedDone size={150} />
            Tudo certo, você já pode começar a postar oportunidades aqui.
            <p>
              Se houver dúvidas, entre em contato <br />
              <strong>jandira@sp.senai.br</strong>
              <br />
              <strong>(11) 4772-4808</strong>
            </p>
            <button onClick={(e) => history.replace("/")}>
              Começar a usar agora
            </button>
          </Concluido>
        ) : (
          <FormCadastro onSubmit={enviar}>
            <h1>Informe seus dados para começarmos</h1>
            <Input
              type="text"
              placeholder="99.999.9999/0009-99"
              label="CNPJ"
              maxLength={18}
              value={empresa.cnpj}
              handler={handlerCnpj}
              mensagemErro={mensagemErro.cnpj}
              required
            />
            <Input
              type="text"
              placeholder="SENAI São Paulo"
              label="Nome fantasia"
              maxLength={300}
              id="nome_fantasia"
              value={empresa.nome_fantasia}
              handler={handlerInput}
              mensagemErro={mensagemErro.nome_fantasia}
              required
            />
            <Input
              type="text"
              placeholder="Ricardo Luiz"
              label="Seu nome"
              maxLength={300}
              id="nome_contato"
              value={empresa.nome_contato}
              handler={handlerNomeContato}
              mensagemErro={mensagemErro.nome_contato}
              required
            />
            <Input
              type="text"
              placeholder="rluiz@sp.senai.br"
              label="Seu e-mail"
              maxLength={300}
              id="email_contato"
              value={empresa.email_contato}
              handler={handlerEmail}
              mensagemErro={mensagemErro.email_contato}
              required
            />
            <Input
              type="text"
              placeholder="(19) 99999-9999"
              label="Telefone de contato"
              maxLength={15}
              id="telefone_contato"
              value={empresa.telefone_contato}
              handler={handlerCelular}
              mensagemErro={mensagemErro.telefone_contato}
              required
            />
            <InputPassword
              placeholder="* * * * * *"
              label="Senha"
              maxLength={15}
              id="telefone_contato"
              value={empresa.senha}
              handler={handlerSenha}
              tip="Deve conter no mínimo 8 caracteres, letras maiúsculas e minúsculas, números e símbolos."
              mensagemErro={mensagemErro.senha}
              required
            />
            <div style={{ marginBottom: 10 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <input
                  type="checkbox"
                  style={{ width: 20 }}
                  value="aceite-termo"
                  id="aceite-termo"
                  checked={aceiteTermo}
                  onChange={() => {
                    setAceiteTermo(!aceiteTermo);
                  }}
                />
                <label for="aceite-termo">
                  <b>
                    Concordo com os{" "}
                    <a
                      id="link-termo"
                      href={"/termo-uso-empresa.html"}
                      target="_blank"
                    >
                      termos de uso
                    </a>{" "}
                    da plataforma
                  </b>
                </label>
              </div>
              {!aceiteTermo && (
                <p
                  style={{
                    color: "red",
                    fontSize: 12,
                    marginLeft: 32,
                    marginTop: -5,
                  }}
                >
                  Você precisa aceitar os termos de uso
                </p>
              )}
            </div>

            <button ref={btnEnviarRef}>Enviar</button>
          </FormCadastro>
        )}
      </Container>
    </>
  );
}

export default CadastroEmpresa;
